// extracted by mini-css-extract-plugin
export var intro = "IssueTeaser-module--intro--Wuy6J";
export var number = "IssueTeaser-module--number---rEDI";
export var root = "IssueTeaser-module--root--+ot3E";
export var title = "IssueTeaser-module--title--5Vf99";
export var titleGroup = "IssueTeaser-module--titleGroup--2t21u";
export var wrapper = "IssueTeaser-module--wrapper--Kmb6V";